import React, { memo } from 'react';
import PropTypes from 'prop-types';
import DateTimeField from './DateTimeField';
import { extendedStateType } from '../../types';
import { NO_STATE } from '../../hooks/useExtendedState';

TimeField.propTypes = {
    label: PropTypes.node,
    value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    validator: PropTypes.func,
    onValidated: PropTypes.func,
    className: PropTypes.string,
    invalidBefore: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    onReset: PropTypes.func,
    isChanged: PropTypes.bool,
    isRequired: PropTypes.bool,
    timeFormat: PropTypes.string,
    isValidDate: PropTypes.func,
    initialViewDate: PropTypes.instanceOf(Date),
    state: extendedStateType,
};

TimeField.defaultProps = {
    onChange: undefined,
    value: undefined,
    validator: null,
    onValidated: undefined,
    inputId: null,
    className: '',
    invalidBefore: null,
    onReset: undefined,
    isChanged: undefined,
    isRequired: false,
    label: null,
    timeFormat: 'HH:mm:ss',
    isValidDate: null,
    initialViewDate: null,
    state: NO_STATE,
};

export const HOUR_AND_MINUTE = 'HH:mm';

function TimeField(props) {
    const {
        label,
        inputId,
        value,
        onChange,
        className,
        validator,
        onValidated,
        invalidBefore,
        onReset,
        isChanged,
        isRequired,
        timeFormat,
        isValidDate,
        initialViewDate,
        state,
    } = props;
    return (
        <DateTimeField
            label={label}
            inputId={inputId}
            value={value}
            onChange={onChange}
            className={className}
            validator={validator}
            onValidated={onValidated}
            invalidBefore={invalidBefore}
            onReset={onReset}
            isChanged={isChanged}
            isRequired={isRequired}
            timeFormat={timeFormat}
            dateFormat={false}
            isValidDate={isValidDate}
            initialViewDate={initialViewDate}
            state={state}
        />
    );
}

export default memo(TimeField);
